import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { RatingPage } from './RatingPage';

/**
 * Wrapper component for the rating gate page that can be used in routes.
 * This component extracts query parameters and passes them to RatingPage.
 */
export const RatingGatePage: React.FC = () => {
  const [searchParams] = useSearchParams();
  
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center py-4 sm:py-8 px-4 sm:px-6">
      <RatingPage
        tenantId={undefined} // Will be handled by API context
        campaignId={searchParams.get('campaign_id') || undefined}
        contactId={searchParams.get('contact_id') || undefined}
        source="web"
        isPublicRoute={true} // Always use public endpoint for this public route
      />
    </div>
  );
};
